import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchMoldReceiving, editMoldMaintenanceData } from './store/slice';
import { actions as maintenanceActions } from './store/slice';
import { showToast } from 'Core/redux/toast/slice';
import { MoldService } from '../../service/api/mold-service';
import MoldMaintenaceModals from './mold-maintenace-modals';
import MoldMaintenanceContent from './mold-maintenance-content';
import MoldMaintenanceTopHead from './mold-maintenance-top-head';
import {
  parseMoldMaintenanceDeepLink,
  normalizeMoldReceiving,
} from './mold-maintenance-deep-link';
const { resetFilters } = maintenanceActions;

const MoldMaintenanceView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const openedDeepLinkKeyRef = useRef(null);

  useEffect(() => {
    dispatch(fetchMoldReceiving({ isReleased: 1, recordFilter: 1 }));
    return () => dispatch(resetFilters());
  }, []);

  useEffect(() => {
    const deepLink = parseMoldMaintenanceDeepLink(location.search);
    if (!deepLink) {
      openedDeepLinkKeyRef.current = null;
      return undefined;
    }

    const key = `${deepLink.toolId}:${deepLink.maintenanceId || ''}:${deepLink.moldInfoId || ''}`;
    if (openedDeepLinkKeyRef.current === key) {
      return undefined;
    }

    let cancelled = false;
    (async () => {
      let mold = {
        toolID: deepLink.toolId,
        moldInfoID: deepLink.moldInfoId,
      };
      if (deepLink.moldInfoId) {
        try {
          const response = await MoldService.getMoldById(deepLink.moldInfoId);
          if (response.status === 200 && response.response) {
            const normalized = normalizeMoldReceiving(response.response);
            mold = {
              ...normalized,
              toolID: deepLink.toolId || normalized?.toolID,
              moldInfoID: deepLink.moldInfoId || normalized?.moldInfoID,
            };
          }
        } catch {
          // Open with ids from the notification if mold lookup fails.
        }
      }

      if (cancelled) {
        return;
      }
      if (!mold.toolID) {
        dispatch(
          showToast({
            message: 'Could not open the maintenance record from this notification.',
            type: 'danger',
          }),
        );
        return;
      }

      dispatch(
        editMoldMaintenanceData({
          ...mold,
          focusedMaintenanceId: deepLink.maintenanceId,
        }),
      );
      openedDeepLinkKeyRef.current = key;
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch, location.search]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Mold Maintenance</h4>
              </div>
            </div>
            <MoldMaintenanceTopHead />
          </div>
          <MoldMaintenanceContent />
          <MoldMaintenaceModals />
        </div>
      </div>
    </div>
  );
};

export default MoldMaintenanceView;
